// Wrappers de Administración · Checklists (plan 2026-10-30 Fase 3,
// T-ljhq). La lista admin, las tiendas asignadas y el PATCH ya viven en
// lib/api/endpoints/checklist-templates.ts (ADR-0079) y se reusan tal
// cual; el detalle (GET /checklist-templates/:id, con la evidencia mínima
// y la severidad sugerida de cada ítem) no tenía wrapper en el dashboard
// y se agrega aquí, junto a la única pantalla que lo usa.

import {
  checklistTemplateDetailResponse,
  type ChecklistTemplateDetailResponse,
  type ChecklistTemplateUpdateBody,
} from "@bitacorapro/api-types";
import { request } from "../../../lib/api/client";
import { checklistTemplatesApi } from "../../../lib/api/endpoints/checklist-templates";

export const checklistsApi = {
  // GET /checklist-templates — toda la organización, inactivas
  // incluidas; trae itemCount/areaCount/assignedAssetCount por plantilla.
  listAdmin: () => checklistTemplatesApi.listAdmin(),
  // GET /checklist-templates/:id — bloques e ítems con evidenceRequirement
  // y defaultSeverityKey. Cualquier miembro autenticado puede leerlo; la
  // pantalla igual lo apaga para quien no administra.
  getDetail: async (templateId: string): Promise<ChecklistTemplateDetailResponse> => {
    const json = await request<unknown>("GET", "core", `/checklist-templates/${templateId}`);
    return checklistTemplateDetailResponse.parse(json);
  },
  // GET /checklist-templates/:id/assets — qué tiendas lo llevan hoy.
  getAssets: (templateId: string) => checklistTemplatesApi.getAssets(templateId),
  // PUT /checklist-templates/:id/assets — reemplazo completo.
  putAssets: (templateId: string, assetIds: string[]) =>
    checklistTemplatesApi.putAssets(templateId, { assetIds }),
  // PATCH /checklist-templates/:id — aquí sólo el alcance (+ assetIds al
  // pasar a tiendas).
  patch: (templateId: string, body: ChecklistTemplateUpdateBody) =>
    checklistTemplatesApi.patch(templateId, body),
};
